export const csvMimeTypes = ['text/csv', 'text/plain'];
